import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AnagraficaComponent } from './anagrafica/anagrafica.component';
import { AttrezzaturaComponent } from './attrezzatura/attrezzatura.component';
import { DipendentiComponent } from './dipendenti/dipendenti.component';
import { UtentiComponent } from './utenti/utenti.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import { EditUtenteComponent } from './modals/edit-utente/edit-utente.component';
import { EditDipendentiComponent } from './modals/edit-dipendenti/edit-dipendenti.component';
import { EditAttrezzaturaComponent } from './modals/edit-attrezzatura/edit-attrezzatura.component';
import { EditAnagraficaComponent } from './modals/edit-anagrafica/edit-anagrafica.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgendaComponent } from './agenda/agenda.component';
import { EditAgendaComponent } from './modals/edit-agenda/edit-agenda.component';
import {MatSelectModule} from '@angular/material/select';
import { NgxMatDateAdapter, NgxMatDatetimePickerModule, NgxMatNativeDateAdapter, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { DatePipe } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import {MatDividerModule} from '@angular/material/divider';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { EditReportComponent } from './modals/edit-report/edit-report.component';
import { PrintconvalidaComponent } from './modals/printconvalida/printconvalida.component';
import { EditNotecantiereComponent } from './modals/edit-notecantiere/edit-notecantiere.component';

// the second parameter 'fr' is optional
registerLocaleData(localeIt, 'it');

export class CustomDateAdapter extends NgxMatNativeDateAdapter {
  getFirstDayOfWeek(): number {
     return 1;
   }
}



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AnagraficaComponent,
    AttrezzaturaComponent,
    DipendentiComponent,
    UtentiComponent,
    EditUtenteComponent,
    EditDipendentiComponent,
    EditAttrezzaturaComponent,
    EditAnagraficaComponent,
    AgendaComponent,
    EditAgendaComponent,
    EditReportComponent,
    PrintconvalidaComponent,
    EditNotecantiereComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatDialogModule,
    HttpClientModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    FormsModule,
    MatRadioModule,
    MatSelectModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatDividerModule
  ],
  providers: [
    NgxMatNativeDateModule,
    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter},
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: LOCALE_ID, useValue: 'it-IT' }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class AppModule { }
